import { defineNuxtPlugin, navigateTo, useNuxtApp, useRuntimeConfig } from "#app";
import { useRoute, useRouter } from "#imports";
export default defineNuxtPlugin(async (_nuxtApp) => {
  const config = useRuntimeConfig();
  const route = useRoute();
  const router = useRouter();
  const i18nConfig = config.public.i18nConfig;
  const normalizeLocales = (locales) => {
    if (Array.isArray(locales)) {
      return locales.reduce((acc, locale) => {
        acc[locale] = {};
        return acc;
      }, {});
    } else if (typeof locales === "object" && locales !== null) {
      return locales;
    }
    return {};
  };
  const handleRedirect = async (to) => {
    const currentLocale = (to.params.locale || i18nConfig.defaultLocale).toString();
    const { name } = to;
    let defaultRouteName = name?.toString().replace("localized-", "").replace(new RegExp(`-${currentLocale}$`), "");
    if (!to.params.locale) {
      if (router.hasRoute(`localized-${to.name?.toString()}-${currentLocale}`)) {
        defaultRouteName = `localized-${to.name?.toString()}-${currentLocale}`;
      } else {
        defaultRouteName = `localized-${to.name?.toString()}`;
      }
      if (!router.hasRoute(defaultRouteName)) {
        return;
      }
      const newParams = { ...to.params };
      newParams.locale = i18nConfig.defaultLocale;
      return navigateTo({ name: defaultRouteName, params: newParams }, { redirectCode: 301, external: true });
    }
  };
  if (import.meta.server) {
    if (i18nConfig.includeDefaultLocaleRoute) {
      await handleRedirect(route);
    }
  }
  router.beforeEach(async (to, from, next) => {
    if (i18nConfig.includeDefaultLocaleRoute) {
      await handleRedirect(to);
    }
    if (next) {
      next();
    }
  });
  const defineI18nRoute = async (routeDefinition) => {
    const currentLocale = (route.params.locale || i18nConfig.defaultLocale).toString();
    const normalizedLocales = normalizeLocales(routeDefinition.locales);
    if (Object.values(normalizedLocales).length) {
      if (normalizedLocales[currentLocale]) {
        const translation = normalizedLocales[currentLocale];
        const nuxtApp = useNuxtApp();
        nuxtApp.$mergeTranslations(translation);
      }
      if (!normalizedLocales[currentLocale]) {
        let defaultRouteName = route.name?.toString().replace("localized-", "").replace(new RegExp(`-${currentLocale}$`), "");
        const resolvedRoute = router.resolve({ name: defaultRouteName });
        const newParams = { ...route.params };
        delete newParams.locale;
        if (i18nConfig.includeDefaultLocaleRoute) {
          if (router.hasRoute(`localized-${defaultRouteName}-${currentLocale}`)) {
            defaultRouteName = `localized-${defaultRouteName}-${currentLocale}`;
          } else {
            defaultRouteName = `localized-${defaultRouteName}`;
          }
          if (!router.hasRoute(defaultRouteName)) {
            return;
          }
          newParams.locale = i18nConfig.defaultLocale;
          newParams.name = defaultRouteName;
        }
        return router.push(resolvedRoute);
      }
    }
  };
  return {
    provide: {
      defineI18nRoute
    }
  };
});
